<script>
  /* Executable code section of the program */
  //Tools importation
  import { getLimitDocuments } from "../apis/APIS";
  import {temporalData,userRealTime} from "../apis/storage"
  import { navigate } from "svelte-routing";

  //Components importation
  import AttendeeSliderCard from "./Cards/AttendeeSliderCard.svelte";
  import EmptyAttendees from "../components/EmptySections/EmptyAttendees.svelte";
  import { element } from "svelte/internal";

  //Auxiliary variables
  export let color;
  let eventAttendees = [];
  export let curretEvent;
  let windowWidth = window.innerWidth;

  (async () => {
    eventAttendees = await getLimitDocuments("users", "event", curretEvent, 13);
    eventAttendees = eventAttendees.filter(element=>element.id !==$userRealTime.id)
  })();

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<body class="principalContainer">
  {#if eventAttendees === undefined || eventAttendees === null || eventAttendees.length == 0}
    <EmptyAttendees />
  {:else}
    <div id="carouselExampleIndicators" class="carousel slide">
      <div
        class="carousel-indicators"
        style="--event-Color: {color}; background-color: {color};"
      >
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>
      <div class="carousel-inner carouselContainer">
        <div class="carousel-item active">
          <AttendeeSliderCard
            attendeesList={eventAttendees.slice(0, 4)}
            avatarColor={color}
          />
          <div style="height: 50px;"></div>
        </div>
        <div class="carousel-item">
          <AttendeeSliderCard
            attendeesList={eventAttendees.slice(4, 8)}
            avatarColor={color}
          />
          <div style="height: 50px;"></div>
        </div>
        <div class="carousel-item">
          <AttendeeSliderCard
            attendeesList={eventAttendees.slice(8, 12)}
            avatarColor={color}
          />
          <div style="height: 50px;"></div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev"
      >
        <span
          class="carousel-control-prev-icon"
          style="--event-Color: {color}; background-color: {color};"
          aria-hidden="true"
        ></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        style="color: black;"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next"
      >
        <span
          class="carousel-control-next-icon"
          style="--event-Color: {color}; background-color: {color};"
          aria-hidden="true"
        ></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div class="btnSeeMore">
      <a class="linkAttendees" href="/socialattendees/{$temporalData.id}"><button class="actionBtn addEventBtn">See More Attendees</button></a>
    </div>
  {/if}
</body>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .principalContainer {
    width: 100%;
    height: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .carousel {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .carouselContainer {
    width: 80%;
    height: auto;
  }
  .carousel-item {
    width: 100%;
    height: auto;
  }
  /*  .carousel-control-prev-icon,.carousel-control-next-icon{
        background-color: #00c261;
    }
    .carousel-indicators{
        background-color: #00c261;
    } */

  .actionBtn {
    width: 30%;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .btnSeeMore {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
  .linkAttendees{
    width: 100%;
    display: flex;
    justify-content: center;
    text-decoration: none;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .principalContainer {
      width: 100%;
      height: auto;
      padding: 5px;
      display: flex;
    }
    .carouselContainer {
      width: 100%;
      height: auto;
    }
    .carousel-control-prev,
    .carousel-control-next {
      width: auto;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }

  /* End of the section */
</style>
